import { ReactComponent } from "./search-line.svg";

interface Props {
  fill?: string;
}

const SearchLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default SearchLineIcon;
